<template>
  <div class="ReviewHearing">
    <TopNavBar navtitle="听力考级评审"></TopNavBar>
    <div class="HearingExmaInfo">
      <!-- 考生信息 -->
      <div class="Examinee">
        <ul class="examinfo" v-if="ExamFormInfo">
          <h1>{{ExamFormInfo.ExamBatch.EB_Name}}</h1>
          <img class="papers" :src="ExamFormInfo.Photo" alt="" />
          <li>
            <label for="">姓名：</label>
            <span>{{ExamFormInfo.Name}}</span>
          </li>
          <li>
            <label for="">准考证号：</label>
            <span>{{ExamFormInfo.ExamNO}}</span>
          </li>
          <li>
            <label for="">专业：</label>
            <span class="warning">{{ExamFormInfo.Majors.MName}}</span>
          </li>
          <li>
            <label for="">级别：</label>
            <span class="warning">{{ExamFormInfo.Grades.GName}}</span>
          </li>
        </ul>
      </div>
      <!-- 基础知识得分 -->
      <div class="BasicsScore">
        <!-- <span>
          基础知识得分：<b>50分</b>
        </span> -->
        <van-button type="warning" @click="ShowVideo">考生监考视频</van-button>
      </div>
      <!-- 考题信息 -->
      <div class="ExmaInfo" v-if="UserLog&&UserLog.QuestionInfoList">
        <van-tabs>
          <van-tab v-for="(qitem,index) in UserLog.QuestionInfoList" :key="index">
            <template #title>题目{{index+1}}
              <van-icon name="checked" v-if="ReviewList.filter(s=>s.EMQ_ID==qitem.EMQ_ID).length>0" />
            </template>

            <h1>第{{ index+1 }}题：{{qitem.TypeInfo.Type_Name}}。（{{qitem.Score}}分）</h1>
            <div v-for="(q,i) in JSON.parse(qitem.Question)" :key="index+'_'+i" class="reply">
              <h2 v-if="q.T==1">{{q.Q}}</h2>
              <img :src="q.Q" alt="" v-if="q.T==2" />
              <audio :src="q.Q" v-if="q.T==3" controls></audio>
            </div>
            <!-- 考生答案 -->
            <h1>考生答题：</h1>
            <div class="reply">
              <h2 v-if="qitem.TypeInfo.AnsweringMethod==1&&qitem.QuestionType == 1&&qitem.Options!='[]'">{{JSON.parse(qitem.Options)[AnswerInfoList.filter(s=>s.EMQ_ID==qitem.EMQ_ID)[0].Answer]}}</h2>
              <img v-if="qitem.TypeInfo.AnsweringMethod==1&&qitem.QuestionType == 2&&qitem.Options!='[]'" :src="JSON.parse(qitem.Options)[AnswerInfoList.filter(s=>s.EMQ_ID==qitem.EMQ_ID)[0].Answer]"></img>
              <audio controls :src="AnswerInfoList.filter(s=>s.EMQ_ID==qitem.EMQ_ID)[0].Answer" v-if="qitem.TypeInfo.AnsweringMethod==2"></audio>
            </div>
            <!-- 评审打分选项 -->
            <div class="GetScore" v-if="qitem.TypeInfo.AnsweringMethod==2">
              <h1>
                <span>请选择得分</span>
                <b>得分：{{ReviewList.filter(s=>s.EMQ_ID==qitem.EMQ_ID)&&ReviewList.filter(s=>s.EMQ_ID==qitem.EMQ_ID).length>0?ReviewList.filter(s=>s.EMQ_ID==qitem.EMQ_ID)[0].Score:''}}分</b>
              </h1>
              <div class="ScordItem">
                <span @click="SelectScore(qitem.EMQ_ID,0)" :class="ReviewList.filter(s=>s.EMQ_ID==qitem.EMQ_ID)&&ReviewList.filter(s=>s.EMQ_ID==qitem.EMQ_ID).length>0&&ReviewList.filter(s=>s.EMQ_ID==qitem.EMQ_ID)[0].Score>=0?'active':''">
                  {{0}}
                </span>
                <span v-for="index in qitem.Score" :key="index" @click="SelectScore(qitem.EMQ_ID,index)" :class="ReviewList.filter(s=>s.EMQ_ID==qitem.EMQ_ID)&&ReviewList.filter(s=>s.EMQ_ID==qitem.EMQ_ID).length>0&&ReviewList.filter(s=>s.EMQ_ID==qitem.EMQ_ID)[0].Score>=index?'active':''">
                  {{index}}
                </span>
              </div>
            </div>
            <div class="GetScore" v-if="qitem.TypeInfo.AnsweringMethod==1">
              <h1>
                <span></span>
                <b>得分：{{ReviewList.filter(s=>s.EMQ_ID==qitem.EMQ_ID)&&ReviewList.filter(s=>s.EMQ_ID==qitem.EMQ_ID).length>0?ReviewList.filter(s=>s.EMQ_ID==qitem.EMQ_ID)[0].Score:''}}分</b>
              </h1>
              <div class="ScordItem">
                <span :class="ReviewList.filter(s=>s.EMQ_ID==qitem.EMQ_ID)&&ReviewList.filter(s=>s.EMQ_ID==qitem.EMQ_ID).length>0&&ReviewList.filter(s=>s.EMQ_ID==qitem.EMQ_ID)[0].Score>=0?'active':''">
                  {{0}}
                </span>
                <span v-for="index in qitem.Score" :key="index" :class="ReviewList.filter(s=>s.EMQ_ID==qitem.EMQ_ID)&&ReviewList.filter(s=>s.EMQ_ID==qitem.EMQ_ID).length>0&&ReviewList.filter(s=>s.EMQ_ID==qitem.EMQ_ID)[0].Score>=index?'active':''">
                  {{index}}
                </span>
              </div>
            </div>
          </van-tab>
        </van-tabs>
      </div>
      <!-- 考生得分信息 -->
      <div class="BasicsScore">
        <span>
          总成绩得分：<b>{{SumScore}}分</b>

          <van-button type="primary" v-if="SumScore>=90">优秀</van-button>
          <van-button type="primary" v-if="SumScore >= 80 && SumScore <= 89">良好</van-button>
          <van-button type="warning" v-if="SumScore >= 60 && SumScore <= 79">及格</van-button>
          <van-button type="danger" v-if="SumScore < 60">不及格</van-button>
        </span>
        <van-button v-if="UserLog&&(!UserLog.QuestionInfoList||ReviewList.length==UserLog.QuestionInfoList.length)" type="primary" @click="SubScore" color="linear-gradient(to right, #ff6034, #ee0a24)">确认提交成绩</van-button>
        <van-button v-if="!UserLog" type="primary" @click="showCanvas = true" color="linear-gradient(to right, #ff6034, #ee0a24)">缺考</van-button>
      </div>
    </div>
    <!-- 考生监考视频 -->
    <van-dialog v-model="Vshow" title="考生监考视频">

      <video-player class="video-player vjs-custom-skin" ref="videoPlayer" :options="playerOptions" :playsinline="true">
      </video-player>

      <!-- <video v-if="Vshow&&UserLog&&UserLog.FileName&&UserLog.FileName!=''" :src="UserLog.FileName+'.webm'" width="100%" height="300px" controls="controls"></video>
      <a :href="UserLog.FileName+'.webm'" v-if="Vshow&&UserLog&&UserLog.FileName&&UserLog.FileName!=''">查看原视频</a>  -->
    </van-dialog>
    <van-dialog v-model="showCanvas" title="考官签名" show-cancel-button :before-close="saveAsImg">
      <sign-canvas class="sign-canvas" ref="SignCanvas" :options="signOptions" v-model="signValue" />
    </van-dialog>
  </div>
</template>

<script>
import TopNavBar from '@/components/TopNavBar.vue';
import videojs from 'video.js';
import 'vue-video-player/src/custom-theme.css';
import 'video.js/dist/video-js.css';
import { videoPlayer } from 'vue-video-player';
import { GetExamFormMusicTheoryReviewInfo, SubmitExaminerReview } from '@/api/examiner';
import SignCanvas from 'sign-canvas';

export default {
  components: {
    TopNavBar,
    SignCanvas,
    videoPlayer,
  },
  data() {
    return {
      Vshow: false,
      IsScore: false,
      radio: '0',
      showCanvas: false, //考官签名插件
      signValue: null,
      signOptions: {
        isSign: true, //签名模式 [Boolean] 默认为非签名模式,有线框, 当设置为true的时候没有任何线框
        isShowBorder: false, //是否显示边框 [可选]
        canvasHeight: 400,
      },
      ExamFormInfo: null,
      ReviewList: [],
      Suggestion: '',
      UserLog: null,
      AnswerInfoList: null,
      SumScore: 0,
      ERT_Code: 0,
      playerOptions: {
        playbackRates: [0.7, 1.0, 1.5, 2.0, 5.0, 10.0, 15.0], //播放速度
        // videojs options
        preload: 'auto',
        muted: true,
        language: 'zh-CN',
        sources: [
          {
            type: 'video/webm',
            src: '',
          },
        ],
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true, // 全屏按钮
        },
        //设置视频播放器的显示高度（以像素为单位）
        height: '400px',
      },
    };
  },
  mounted() {
    if (this.$route.query.EF_ID != undefined && this.$route.query.EF_ID > 0) {
      this.EF_ID = this.$route.query.EF_ID;
      GetExamFormMusicTheoryReviewInfo({ EF_ID: this.EF_ID })
        .then(res => {
          this.ExamFormInfo = res.OtherMsg.ExamFormIno;
          if (res.item) {
            this.UserLog = res.item;
            if (this.UserLog && this.UserLog.FileName && this.UserLog.FileName != '') {
              this.UserLog.FileName = 'https://guizhoumusic.oss-cn-shenzhen.aliyuncs.com/' + this.UserLog.FileName;

              this.playerOptions.sources[0].src = this.UserLog.FileName + '.mp4';
              console.log('this. :>> ', this.playerOptions);
            }
            this.AnswerInfoList = JSON.parse(this.UserLog.AnswerInfo);
            if (res.OtherMsg.ExaminerReview && res.OtherMsg.ExaminerReview.Judgement) {
              this.ReviewList = JSON.parse(res.OtherMsg.ExaminerReview.Judgement);
              this.ERT_Code = res.OtherMsg.ExaminerReview.ERT_Code;
              this.ER_ID = res.OtherMsg.ExaminerReview.ER_ID;
              this.Suggestion = res.OtherMsg.ExaminerReview.Suggestion;
              this.signImg = res.OtherMsg.ExaminerReview.Signature;
            } else {
              if (this.UserLog && this.UserLog.QuestionInfoList) {
                this.UserLog.QuestionInfoList.filter(s => s.TypeInfo.AnsweringMethod == 1).forEach(element => {
                  let s = 0;
                  if (this.AnswerInfoList) {
                    let a = this.AnswerInfoList.filter(s => s.EMQ_ID == element.EMQ_ID);
                    if (a && a[0].Answer.toString() == element.Answer) {
                      s = element.Score;
                    }
                  }
                  this.ReviewList.push({ EMQ_ID: element.EMQ_ID, Score: s });
                });
              }
            }
            this.SumScore = 0;
            this.ReviewList.forEach(element => {
              this.SumScore += element.Score;
            });
          }
        })
        .catch(err => {
          console.log('err :>> ', err);
          this.$toast.fail('考试记录不存在');
          //this.$router.push('/Assessment');
        });
    } else {
      this.$router.push('/ExamTimeList');
    }
  },
  methods: {
    SubScore() {
      if (this.ReviewList.length != this.UserLog.QuestionInfoList.length) {
        this.$toast.fail('您还有题目没有打分');
        return;
      }
      this.showCanvas = true;
    },
    SelectScore(EMQ_ID, Score) {
      if (this.ReviewList.filter(s => s.EMQ_ID == EMQ_ID) && this.ReviewList.filter(s => s.EMQ_ID == EMQ_ID).length > 0) {
        this.ReviewList.filter(s => s.EMQ_ID == EMQ_ID)[0].Score = Score;
      } else {
        this.ReviewList.push({ EMQ_ID: EMQ_ID, Score: Score });
      }

      this.SumScore = 0;
      this.ReviewList.forEach(element => {
        this.SumScore += element.Score;
      });
    },
    ShowVideo() {
      this.Vshow = true;
    },

    /**
     * 清除画板
     */
    canvasClear() {
      this.$refs.SignCanvas.canvasClear();
    },

    /**
     * 保存图片，提交评审内容
     */
    saveAsImg(action, done) {
      if (action === 'confirm') {
        const img = this.$refs.SignCanvas.saveAsImg();
        SubmitExaminerReview({
          EF_ID: this.EF_ID,
          Judgement: JSON.stringify(this.ReviewList),
          ERT_Code: this.ERT_Code,
          Suggestion: this.Suggestion,
          Signature: img,
        })
          .then(res => {
            this.$toast.success('评审成功');
            this.signImg = '已评审';
            done();
          })
          .catch(err => {
            done();
          });
      } else {
         this.$refs.SignCanvas.canvasClear();
        done();
      }
    },
  },
};
</script>

<style>
.Examinee {
  width: 96%;
  margin: 10px auto;
  box-sizing: border-box;
}
.Examinee h1 {
  color: #241f87;
  font-weight: bold;
  padding: 5px 0;
  font-size: 4.8vw;
}
.Examinee ul {
  border-radius: 10px;
  padding: 5px;
  background: #fff;
  margin-bottom: 15px;
  border: solid 1px #f2f2f2;
  position: relative;
  text-align: center;
  box-sizing: border-box;
}
.Examinee ul .papers {
  width: 40vw;
}
.Examinee ul .icon-baomingchenggong {
  position: absolute;
  right: 5%;
  top: 15%;
  color: #07c160;
  font-size: 20vw;
}
.Examinee ul li {
  display: flex;
  justify-content: space-between;
  justify-items: center;
  align-items: center;
  padding: 5px 10px;
  box-sizing: border-box;
  border-bottom: solid #f2f2f2 1px;
}
.Examinee ul li:last-child {
  border: 0;
}
.Examinee ul li.btn-gather {
  justify-content: center;
}
.Examinee ul li.btn-gather button {
  margin: 10px 5px;
  padding: 5px;
  display: block;
  width: 100%;
}
.Examinee ul li label i {
  margin-right: 3px;
  font-size: 5vw;
}
.Examinee ul li label {
  color: #666;
  font-weight: 300;
}
.Examinee ul li .van-button i {
  margin-right: 5px;
}
.Examinee ul li span.van-tag {
  padding: 3px 8px;
  font-size: 3vw;
  display: inline-block;
}
.Examinee ul li .fee {
  color: #fa195a;
  font-weight: bold;
  font-size: 4.8vw;
}
.Examinee ul li .notpass {
  width: 60%;
  font-size: 3.2vw;
  color: #ff976a;
  line-height: 1.6;
}
.BasicsScore {
  width: 94%;
  margin: 15px auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.BasicsScore span b {
  color: crimson;
  font-size: 16px;
}
.BasicsScore .van-button {
  width: 40%;
}
.Examinee .examinfo {
  position: relative;
}
.Examinee .examinfo img {
  position: absolute;
  right: 2%;
  width: 80px;
}
.Examinee .examinfo li {
  justify-content: flex-start;
  align-items: center;
}
.HearingExmaInfo .ExmaInfo img {
  width: 90%;
}
.HearingExmaInfo .ExmaInfo .reply audio {
  height: 30px;
  width: 100%;
}
.HearingExmaInfo .ExmaInfo {
  width: 96%;
  margin: 10px auto;
  box-sizing: border-box;
  background: #fff;
  padding: 0 2% 2% 2%;
}
.HearingExmaInfo .ExmaInfo .van-tabs .van-tabs__content .van-tab__pane h1 {
  margin: 10px auto;
  padding: 5px 2%;
  text-align: left;
  line-height: 1.5;
  font-size: 16px;
  font-weight: bold;
  background: aliceblue;
}
.GetScore h1 {
  display: flex;
  justify-content: space-between;
}
.GetScore .ScordItem {
  display: flex;
  flex-wrap: wrap;
  justify-content: start;
}
.GetScore .ScordItem span {
  background: #f2f2f2;
  width: 5%;
  border: solid 1px #e1e1e1;
  border-radius: 3px;
  padding: 1%;
  margin: 1%;
  display: inline-block;
  text-align: center;
}
.GetScore .ScordItem span.active {
  background: crimson;
  color: #fff;
}
.ReviewHearing .van-dialog .van-dialog__content {
  padding: 2%;
}
</style>